import { z } from 'zod';
import { SearchActivitiesTopActivitySchema } from './search-activities.schemas';

/**
 * Client-safe zod schemas + inferred types for the `get_activity_details` tool
 * (FUN-4938). NO `server-only` import so client components can `safeParse` the
 * dynamic `tool.output` blobs from `UIMessage` parts.
 *
 * The `found` payload reuses `SearchActivitiesTopActivitySchema` — the EXACT
 * grounding-field shape `search_activities` returns for its top-N — so the model
 * reads one activity shape everywhere.
 */
export const GetActivityDetailsOutputSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('found'), activity: SearchActivitiesTopActivitySchema }),
    z.object({ status: z.literal('not_found') }),
    z.object({
        status: z.literal('multiple'),
        /** Small disambiguation list when a name matched several distinct activities. */
        matches: z.array(z.object({ id: z.string(), title: z.string() })),
    }),
]);
export type GetActivityDetailsOutput = z.infer<typeof GetActivityDetailsOutputSchema>;
